<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="cover"><img alt="Missing Cover" src="Images/9780830861255.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?8f1da0e4